import { Component, Input, OnInit, ViewEncapsulation, TemplateRef, ContentChild} from '@angular/core';
// import * as rslice from 'ramda/src/slice';
import * as rslice from 'ramda/src/slice'
import * as indexOf from 'ramda/src/indexOf';
import * as clone from 'ramda/src/clone';
import * as map from 'ramda/src/map';

const rindexOf = indexOf;
const slice = rslice;
const rmap = map;
const rclone= clone;

@Component({
  selector: 'app-comments-custom',
  templateUrl: './comments-custom.component.html',
  styleUrls: ['./comments-custom.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class CommentsCustomComponent implements OnInit {
  showMore: Boolean = true;
  @Input() avaImageQuery:string;
  @Input() avaImageUrl:string;
  @Input() showMoreBtn: Boolean;
  offset : number = 0;
  currentComments :any[];
  @Input() contents: any[];
  @Input() mainCommentdisplayNo: number;
  @ContentChild('parentComments',{static:false}) parentCommentsTmpl: TemplateRef<any>; 
  @ContentChild('ChildComments',{static:false}) ChildCommentsTmpl: TemplateRef<any>;
  constructor() {}

  ngOnChanges() {
      if(this.contents){
        this.currentComments = this.allowLimitedSubcomments(0,this.mainCommentdisplayNo,this.contents)  
      }
  }
  ngOnInit() {
  }

  getComments(event:any,data:any,contentList:any[],i:number,type:string,parentContents:any[],pi:number) {
     type === 'parent' ? this.loadParentComments(data,contentList,i) : this.loadChildComments(data,contentList,i,parentContents,pi)
  }

  indexOfComment = (data:any,list:any[]) => rindexOf(data,list)

  loadParentComments = (data:any,contentList:any[],i:number) => {
    const slicedContents:any[] =slice(i+1)(i+1+this.mainCommentdisplayNo)(contentList)
    const updatedSubcommnets= this.allowLimitedSubcomments(0,this.mainCommentdisplayNo,slicedContents) 
    this.currentComments.push(...updatedSubcommnets)
    if(this.contents.length === this.currentComments.length ){
      this.showMoreBtn = !this.showMoreBtn;
    }
  }

  loadChildComments = (data:any,contentList:any[],i:number,parentContents:any[],pi:number) => {
    const originalNodes:any[] = parentContents[pi].nodes
    const slicedContents:any[] =slice(i+1)(i+1+this.mainCommentdisplayNo)(originalNodes)
    this.currentComments[pi].nodes.push(...slicedContents)
  }

  sliceChildeComments = (child) =>  {
    if(child.nodes){
      child.nodes = slice(0,this.mainCommentdisplayNo)(child.nodes)
      return child
    }else{
      return child
    }
  }

  allowLimitedSubcomments = (startIndex:number,endIndex:number,list:any[]) => rmap(this.sliceChildeComments, rclone(slice(startIndex,endIndex)(list)))



 



}
